import * as React from 'react';

const SupportAgentIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
      fill="url(#paint0_linear_454_26131)"
      fillOpacity="0.5"
    />
    <path
      d="M10 16.5C9.93982 16.5 9.8696 16.5 9.80941 16.5L11.1335 12.8488H12.9591C13.2801 12.8488 13.6312 12.598 13.7415 12.2971L15.186 8.33488C15.4267 7.68287 15.0455 7.15123 14.3634 7.15123H11.8256L9.69907 13.0093L8.49537 16.3295C5.63657 15.6474 3.5 13.0795 3.5 10C3.5 7.02083 5.50617 4.50309 8.2446 3.74074L7.00077 7.16126L4.93441 12.8488H6.30864L8.06404 8.01389H9.09722L7.34182 12.8488H8.71605L10.3611 8.34491C10.6019 7.6929 10.2307 7.16126 9.53858 7.16126H8.375L9.70911 3.51003C9.80941 3.51003 9.89969 3.5 10 3.5C13.5911 3.5 16.5 6.40895 16.5 10C16.5 13.591 13.5911 16.5 10 16.5ZM13.9321 8.01389H12.8989L11.4444 11.9961H12.4776L13.9321 8.01389Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_454_26131"
        x1="10"
        y1="-2.94753"
        x2="10"
        y2="23.0093"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A355D" />
        <stop offset="1" stopColor="#6ACAD8" />
      </linearGradient>
    </defs>
  </svg>
);

export default SupportAgentIcon;
